// extracted by mini-css-extract-plugin
module.exports = {"ResourceAssign":"ResourceAssign_ResourceAssign__3kB_-","Row":"ResourceAssign_Row__p42qH","RowLabel":"ResourceAssign_RowLabel__26NNY"};